import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  // HelpCircle,
  LogOut,
  Phone,
  ChevronRight,
  // FileQuestion,
  CreditCard,
  Bookmark,
} from "lucide-react";
// import { PaymentMethodsIcon } from "../assets/icons/icons.jsx";
import { dictionary } from "../utils/dictionary";
import ToggleSwitch from "../components/onboarding/ui/ToggleSwitch.js";
import { getCurrency, setCurrency } from "../utils/indexedDBUtils.js";
import { useCallback, useEffect, useState } from "react";
import { SettingsCard } from "../components/cards/SettingCard.js";
// import { validators } from "tailwind-merge";

const SettingsPage = () => {
  const { language } = useAuth();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [currencyLocal, setCurrencyLocal] = useState<boolean>(false);

  const fetchCurrency = async () => {
    const value = await getCurrency();
    setCurrencyLocal(value);
  };

  useEffect(() => {
    fetchCurrency();
  }, []);

  const handleCurrencyChange = async () => {
    const value = !currencyLocal;
    setCurrencyLocal(value);
    await setCurrency(value);
    window.dispatchEvent(new Event("currencyChanged"));
  };

  const handleLogout = useCallback(() => {
    logout();
    navigate("/");
  }, [logout, navigate]);

  const settingsOptions = [
    // {
    //   icon: CreditCard,
    //   label: dictionary["payment-methods"][language],
    //   onClick: () => navigate("/payment-methods")
    // },
    {
      icon: CreditCard,
      label: dictionary["integrations"][language],
      onClick: () => navigate("/integrations"),
    },
    {
      icon: Bookmark,
      label: dictionary["manage-membership"][language],
      onClick: () => navigate("/membership"),
    },
    {
      icon: LogOut,
      label: dictionary["logout"][language],
      rightElement: (
        <button
          onClick={handleLogout}
          className="px-10 py-2 text-[#6A6A6A] border border-gray-400 rounded-lg font-semibold shadow transition-all
            hover:bg-[#F5F6FA] hover:text-[#636DF2]
            group-hover:shadow-lg group-hover:scale-105"
        >
          {dictionary["go-out"][language]}
        </button>
      ),
    },
  ];

  return (
    <div
      className="flex flex-col px-4 md:justify-center md:max-w-[510px] md:mx-auto md:min-h-screen"
    >
      <Toaster position="top-right" />

      {/* Header */}
      <div className="w-full flex items-center justify-between mb-6 md:mb-8 md:max-w-[510px] md:mx-auto">
        <h1 className="text-xl md:text-2xl font-bold text-gray-900">
          {dictionary["settings"][language]}
        </h1>
      </div>

      {/* Settings Cards Container */}
      <div className="w-full flex flex-col gap-4 md:gap-6 md:max-w-[510px] md:mx-auto">
        {settingsOptions.map((option, idx) => (
          <SettingsCard
            key={idx}
            icon={option.icon}
            label={option.label}
            onClick={option.onClick}
            rightElement={option.rightElement}
          />
        ))}
      </div>
    </div>
  );
};

export default SettingsPage;
